import React, { useRef, useState, useEffect } from "react";
import { Button } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormControl, Input, InputLabel, Select, MenuItem } from "@mui/material";
import userService from "../../services/userService";

const UserEditModal = (props) => {
	
	let [ selectAccessLevel, setSelectAccessLevel ] = useState(props.user? props.user.access_level : 3);
	
	const firstname = useRef(null);
	const lastname = useRef(null);
	const email = useRef(null);
	
	const handleAccessLevelChange = (e) => {
		setSelectAccessLevel(e.target.value);
	}
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleSubmit = () => {
		props.user.firstname = firstname.current.value;
		props.user.lastname = lastname.current.value;
		props.user.email = email.current.value;
		props.user.access_level = selectAccessLevel;
		props.onSubmit(props.user);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleSubmit();
	};
	
	const handleCancel = () => {
		props.onClose()
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	useEffect(() => {
		setSelectAccessLevel(props.user? props.user.access_level : 3);
	}, [props.user]);
	
	return (
		<Dialog
			open={props.user? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Edit User
			</DialogTitle>
			<DialogContent>
				<form onSubmit={handleSubmitForm} autoComplete="off">
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="firstname">Firstname</InputLabel>
						<Input
							inputRef={firstname}
							id="firstname"
							type="firstname"
							autoComplete="off"
							defaultValue={props.user? props.user.firstname : ""}
						/>
					</FormControl>
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="lastname">Lastname</InputLabel>
						<Input
							inputRef={lastname}
							id="lastname"
							type="lastname"
							autoComplete="off"
							defaultValue={props.user? props.user.lastname : ""}
						/>
					</FormControl>
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="email">Email</InputLabel>
						<Input
							inputRef={email}
							id="new_email"
							type="email"
							autoComplete="off"
							defaultValue={props.user? props.user.email : 3}
						/>
					</FormControl>
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="access_level" sx={{ backgroundColor: "background.inputLabel" }}>
							Access Level
							</InputLabel>
						<Select
							id="access_level"
							autoComplete="off"
							value={selectAccessLevel}
							onChange={handleAccessLevelChange}
						>
							{(userService.AccessLevel() === 1) &&
								<MenuItem value={1}>Super Admin</MenuItem>
							}
							<MenuItem value={2}>Company Admin</MenuItem>
							<MenuItem value={3} selected>Company User</MenuItem>
						</Select>
					</FormControl>
				</form>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleSubmit} autoFocus>Submit</Button>
			</DialogActions>
		</Dialog>
	);
};

export default UserEditModal;